var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C37.7025 5.15406e-07 48 10.2975 48 23V25C48 37.7025 37.7025 48 25 48H23C10.2975 48 0 37.7025 0 25V23C5.1544e-07 10.2975 10.2975 0 23 0H25Z",
    fill: "#D0F8FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 27.2002L20.1333 29.3335L24.9333 24.5335M20.1333 19.7335V16.7468C20.1333 15.5521 20.1333 14.9547 20.3659 14.4983C20.5704 14.0969 20.8967 13.7705 21.2982 13.566C21.7545 13.3335 22.3519 13.3335 23.5467 13.3335H31.6533C32.8481 13.3335 33.4455 13.3335 33.9018 13.566C34.3033 13.7705 34.6296 14.0969 34.8341 14.4983C35.0667 14.9547 35.0667 15.5521 35.0667 16.7468V24.8535C35.0667 26.0483 35.0667 26.6457 34.8341 27.102C34.6296 27.5034 34.3033 27.8298 33.9018 28.0343C33.4455 28.2668 32.8481 28.2668 31.6533 28.2668H28.6667M17.1467 34.6668H25.2533C26.4481 34.6668 27.0455 34.6668 27.5018 34.4343C27.9033 34.2298 28.2296 33.9034 28.4341 33.502C28.6667 33.0457 28.6667 32.4483 28.6667 31.2535V23.1468C28.6667 21.9521 28.6667 21.3547 28.4341 20.8983C28.2296 20.4969 27.9033 20.1705 27.5018 19.966C27.0455 19.7335 26.4481 19.7335 25.2533 19.7335H17.1467C15.9519 19.7335 15.3545 19.7335 14.8982 19.966C14.4967 20.1705 14.1704 20.4969 13.9659 20.8983C13.7333 21.3547 13.7333 21.9521 13.7333 23.1468V31.2535C13.7333 32.4483 13.7333 33.0457 13.9659 33.502C14.1704 33.9034 14.4967 34.2298 14.8982 34.4343C15.3545 34.6668 15.9519 34.6668 17.1467 34.6668Z",
    stroke: "#087E8B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSquare);
export default __webpack_public_path__ + "static/media/checkSquare.ff798369a0177a24c938e1a7e5b25c3e.svg";
export { ForwardRef as ReactComponent };